import { styled } from '@mui/material';

export const ReviewsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export const ReviewContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));
